import React from "react";
import moment from "moment";
import {
  Layout,
  message,
  Button,
  Row,
  Col,
} from "antd";
import TableWrapper from "../elements/TableWrapper";
import ManageTaxForm from "../elements/ManageTaxForm"
import MiCompAPI from "./../../util/api";
const { Content } = Layout;
const columns = [
  {
    title: 'Brackets',
    dataIndex: 'tax_tange',
  }, {
    title: 'Tax Rate',
    dataIndex: 'tax_rate',
    render: (text, record) =>text+"%"
  }, {
    title: 'Effective Date',
    dataIndex: 'tax_eff_dt',
    render: (text, record) => record["tax_eff_dt"] !== null && record["tax_eff_dt"] !== "" ? moment(record["tax_eff_dt"]).format("MM/DD/YYYY") : "",
    sorter: (a, b) => new Date(a.tax_eff_dt) - new Date(b.tax_eff_dt),
    sortDirections: ["descend", "ascend"]
  }, {
    title: 'Termination  Date',
    dataIndex: 'tax_term_dt',
    render: (text, record) => record["tax_term_dt"] !== null && record["tax_term_dt"] !== "" ? moment(record["tax_term_dt"]).format("MM/DD/YYYY") : "",
    sorter: (a, b) => new Date(a.tax_term_dt) - new Date(b.tax_term_dt),
    sortDirections: ["descend", "ascend"]
  }];
class TaxProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      profiles: [],
      errors: null,
      filedata: null,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  uploadTaxProfile = () => {
    if (this.state.filedata) {
      if(this.state.filedata.docName.split('.')[1]==="xls"||this.state.filedata.docName.split('.')[1]==="xlsx"){
        this.api.invoke(
          "Import_TaxProfile",
          "post",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                document.getElementById('files').value = "";
                message.destroy();
                this.setState({
                  errors: null,
                  filedata: null
                });
                message.success(data.statusMessage, 3);
                this.getTaxProfiles();
              } else {
                this.setState({
                  errors: data.data
                })
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            }
          },
          this.state.filedata
        );
      }else{
        message.error("Invalid File Format!, Please upload xls or xlsx File", 3);
      }
    } else {
      message.destroy();
      message.error("Please select file to upload", 3);
    }
  }
  handleAddDocument = async (evt) => {
    var f = evt.target.files[0]; 
    if (f.name.split('.')[1] !== 'xls' && f.name.split('.')[1] !== 'xlsx') {
      message.error("Invalid File Format!, Please upload xls or xlsx File", 3);
    }
    this.setState({
      filedata: {
        base64file: await this.convertBase64(f),
        docName: f.name
      }
    });
  }
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }
  getTaxProfiles=(date)=> {
    this.api.invoke(
      "GetAllTaxProfilesBYStateandEffictiveDate",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({ isLoading: false, profiles: data.data });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }, date
    );
  }
  render() {
    return (
      <Content>
        <div className="mi_main_div">
          <Row span={24}>
            <Col span={24}>
              <ManageTaxForm type="payment" submitHandler={this.getTaxProfiles}></ManageTaxForm>
            </Col>
          </Row>
          <Row span={24} style={{marginTop:'15px'}}>
            <Col span={24}>
              <TableWrapper rowKey="tax_id" bordered={true} columns={columns} data={this.state.isLoading ? null : this.state.profiles}
                loading={this.state.isLoading}
                title="Tax Profiles" search={true}
              />
            </Col>
          </Row>
        
          <Row span={24}>
            <Col span={24}>
              <input type="file" id="files" name="files" onChange={this.handleAddDocument} />
              <Button type="primary"  className="submit-button" onClick={this.uploadTaxProfile}>
                <i className="fa fa-upload" aria-hidden="true"></i>
                Upload Tax Profiles</Button>
              <Button type="primary"  className="submit-button" style={{ marginTop: "10px" }} onClick={() => window.open(process.env.REACT_APP_SAMPLE_URL+"samplefiles/TaxProfies.xlsx", "_blank")}>
                <i className="fa fa-download" aria-hidden="true"></i>
  Sample Document
                 </Button>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={24} >
              {this.state.errors ?
                <div className="mi_well">
                  {this.state.errors.map(element => {
                    return (<p className="mi_wepp_p">{element}</p>)
                  })}
                </div> : ""}
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default TaxProfile;